import Section from '../index'
import cn from 'classnames'
import s from '../../styles.module.css'
import { createSlug } from '../../../../utilities/blog'
import Link from 'next/link'
import WorkoutIcon from '../../icons/workout'

const onlyFeaturedCategories = categories =>
  categories.filter(({ fields }) => fields.featured)

const FitnessGoalCategories = ({ categories }) => {
  return (
    <div>
      <Section
        title="What is your fitness goal?"
        titleLocation="center"
        className={cn(s.sectionWithPadding, s.sectionGray50)}>
        <div className={s.categoryCards}>
          {onlyFeaturedCategories(categories).map((category, i) => {
            const slug = createSlug(category.fields)
            return (
              <Link
                key={`category-${i}`}
                href={`${slug}`}
                className={cn(s.category, s[`categoryGradient${i % 12}`])}>
                <WorkoutIcon color="#fff" size={16} />
                <span className={s.categoryName}>{category.fields.name}</span>
              </Link>
            )
          })}
        </div>
      </Section>
    </div>
  )
}

export default FitnessGoalCategories
